// import '../../plugins/jquery.hasClasses.js';

//スクロールしたらbodyにis-scrolledを付与
window.addEventListener("scroll", () => {
  const scrollY = document.querySelector(".l-header").getBoundingClientRect().height * 0.6;
  const foot = document.querySelector("body").getBoundingClientRect();
  if(window.scrollY >= scrollY && window.scrollY <= (foot.height - window.innerHeight)) {
    document.querySelector('body').classList.add("is-scrolled");

    // console.log($(window).scrollTop());
  } else {
    document.querySelector('body').classList.remove("is-scrolled");
    // setTimeout(function() {
    //   // if(!$('body').hasClass('is-open')) {
    //   //   $('body').removeClass("is-scrolled");
    //   // }
    //   if(!$('body').hasClasses(['is-open', 'is-searchContent--showPage'], true)) {
    //     $('body').removeClass("is-scrolled");
    //   }

    // }, 100);
  }
  
})
$(window).scroll(function() {
  scrollHeight = $(document).height();
  scrollPosition = $(window).height() + $(window).scrollTop(); 
  footHeight = $(".l-footer").innerHeight(); 
  if ( scrollHeight - scrollPosition  <= footHeight ) { 
    $(".c-accordion").css({
      "position":"relative", 
      "bottom": 0,
    });
  } else { 
    $(".c-accordion").css({
        "position":"fixed", 
        "bottom": "0px",
        "left": "0px" 
    });
  }
}
);


// $(window).scroll(function() {
//   if($(window).scrollTop() >= 1) {

//     $('body').addClass("is-scrolled");
//     // console.log($(window).scrollTop());
//   } else {
//     // setTimeout(function() {
//     //   // if(!$('body').hasClass('is-open')) {
//     //   //   $('body').removeClass("is-scrolled");
//     //   // }
//     //   if(!$('body').hasClasses(['is-open', 'is-searchContent--showPage'], true)) {
//     //     $('body').removeClass("is-scrolled");
//     //   }

//     // }, 100);
//     $('body').removeClass("is-scrolled");
//   }
// });


